<template>
  <v-container>
    <div
      v-if="!Loading">
      <v-row justify="center">
        <v-col md="10">
          <v-container>
            <v-card>
              <v-toolbar
                color="primary"
                dark>
                <v-toolbar-title>
                  <v-icon>schedule</v-icon>授業一覧
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <span
                  class="text--primary"
                  v-if="!noRecords">
                  {{ this.records.length() }}件の授業完了報告があります。
                </span>
                <span
                  class="text--primary"
                  v-else>
                  完了した授業は現在ありません。
                </span>
                <span
                  class="text--primary"
                  v-if="!noLessons">
                  {{ this.lessons.length() }}件の授業予定があります。
                </span>
                <span
                  class="text--primary"
                  v-else>
                  授業予定は現在ありません。
                </span>
              </v-card-text>
            </v-card>
          </v-container>
          <v-container>
            <v-card
              v-if="!noRecords">
              <v-card-title>
                <h4>完了授業一覧</h4>
                <v-spacer></v-spacer>
                <v-icon
                  @click="recordDisplay= !recordDisplay">
                  keyboard_arrow_down
                </v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <div v-if="recordDisplay">
                <TeacherLessonRecord
                  v-for="student in this.recordStudents.get()"
                  :key="student.id"
                  :student="student"
                  :records="records"
                />
                <v-card-title>
                  <v-col
                    offset-md="5"
                    class="subheading">
                    受取報酬(授業完了分)
                  </v-col>
                  <v-col md="2">
                    <span class="font-weight-bold headline">{{ this.records.getPaymentAmount() }}</span>
                    <span class="subheading">円</span>
                  </v-col>
                </v-card-title>
              </div>
            </v-card>
          </v-container>
          <v-container>
            <v-row>
              <v-col>
                <v-card
                  v-if="!noLessons">
                  <v-card-title>
                    <h4>授業予定一覧</h4>
                    <v-spacer></v-spacer>
                    <v-icon
                      @click="scheduleDisplay= !scheduleDisplay">
                      keyboard_arrow_down
                    </v-icon>
                  </v-card-title>
                  <v-divider></v-divider>
                  <div v-if="scheduleDisplay">
                    <LessonScheduleCard
                      v-for="student in this.students.get()"
                      :key="student.id"
                      :student="student"
                      :lessons="lessons"
                      @deleteStudent="deleteStudent(student)"
                    />
                  </div>
                </v-card>
              </v-col>
            </v-row>
          <v-dialog
            v-model="hasDeleted"
            max-width="500"
            persistent>
            <v-card>
              <v-card-title>
                授業を削除しました。
              </v-card-title>
              <v-container>
                <v-row justify="end">
                <v-card-actions>
                  <v-btn
                    class="ma-1"
                    outlined
                    rounded
                    @click="hasDeleted=false">
                    はい
                  </v-btn>
                </v-card-actions>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
          </v-container>
        </v-col>
      </v-row>
    </div>
    <div
      v-else
      class="max-height">
      <Loading/>
    </div>
  </v-container>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { LessonRecordRepository } from '@/repository/LessonRecordRepository.js'
import { StudentRepository } from '@/repository/StudentRepository.js'
import Loading from '@/components/organisms/Loading.vue'
import LessonScheduleCard from '@/components/organisms/teacher/LessonScheduleCard.vue'
import TeacherLessonRecord from '@/components/organisms/teacher/TeacherLessonRecord.vue'

export default {
  name: "LessonSchedules",
  components: {
    "Loading": Loading,
    "LessonScheduleCard": LessonScheduleCard,
    "TeacherLessonRecord": TeacherLessonRecord,
  },
  data(){
    return {
      Loading: true,
      teacher: this.$store.getters.teacher,
      lessons: null,
      records: null,
      students: null,
      recordStudents: null,
      scheduleDisplay: true,
      recordDisplay: true,
      hasDeleted: false
    }
  },
  methods: {
    deleteStudent(student) {
      this.hasDeleted = true
      this.students.remove(student.id)
      if (this.lessons.get().length === 1) {
        this.lessons.remove(student.lessons.get()[0].id)
      }
    }
  },
  created: async function() {
    const studentRepo = new StudentRepository(firestore)
    const recordRepo = new LessonRecordRepository(firestore)
    this.lessons = this.teacher.lessons
    this.students = await studentRepo.collect(this.lessons.getStudentIds())
    this.records = await recordRepo.listByTeacherId(this.teacher.uuid)
    this.records.sortByDate()
    this.recordStudents = await studentRepo.collect(this.records.getLessonStudentIds())
    this.Loading = false
  },
  computed: {
    noRecords() {
      return this.records.get().length === 0
    },
    noLessons() {
      return this.lessons.get().length === 0
    }
  }
}
</script>
